export enum SliderGallerySlideNavigation {
    ARROW_NEXT = "arrow_next",
    ARROW_PREV = "arrow_prev",
    SWIPE = "swipe"
}
export enum SliderGallerySlideNavigation {
    ARROW_NEXT = "arrow_next",
    ARROW_PREV = "arrow_prev",
    SWIPE = "swipe"
}
